import React from 'react'
// ##
import DistrictsTable from '../../modules/District/components/DistrictsTable'

export default function SectionPage() {
  return <DistrictsTable />
}
